'use strict';

$(document).ready(function () {
    // What Our Students Are Saying
    $('.student-review-card__slides').slick({
        dots: true,
        centerMode: true,
        slidesToShow: 1,
        variableWidth: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    variableWidth: true,
                    infinite: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    variableWidth: true,
                    infinite: false
                }
            }
        ]
    });

    $(document).on('afterChange', '.student-review-card__slides', function (slick) {
        $('.slick-slide:not(.slick-active) .c-review-card__quote').attr('tabindex', '-1');
        $('.slick-slide:not(.slick-active) .c-review-card__name').attr('tabindex', '-1');
        $('.slick-slide:not(.slick-active) .c-review-card__subject').attr('tabindex', '-1');
        $(this).find('.slick-active .c-review-card__quote').attr('tabindex', '0');
        $(this).find('.slick-active .c-review-card__name').attr('tabindex', '0');
        $(this).find('.slick-active .c-review-card__subject').attr('tabindex', '0');
        $(this).find('.slick-current').find('.c-review-card__quote').focus();
    });
});
